<template>
  <div class="logo">
    <router-link class="logo-main" :to="url">
      <img :src="logo">
      <p>财务数字化管理平台</p>
    </router-link>
  </div>
</template>

<script>

import { getAdminType } from '@/common/js/storage';
export default {
  props: {
    logo: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      url: ''
    }
  },

  created() {
    let adminType = getAdminType()
    if (adminType == 2) {
      this.url = '/fire'
    } else if(adminType == 4) {
      this.url = '/finance'
    }else {
      this.url = '/oneLevel/systemIndex'
    }
  },

  methods: {
  }
}
</script>

<style lang='scss' scoped>
.logo {
  width: 100%;
  height: 56px;
  padding: 10px 10px 10px 13px;
  box-sizing: border-box;
  @include flex-center;
  .logo-main {
    @include flex-center;
    text-decoration: none;
    img {
      width: 40px;
      height: 40px;
    }
    p {
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      margin-left: 5px;
    }
  }
}
</style>